// Navbar — sticky white bar with the logo, a search trigger, and a single
// "Knowledge Base" link.
//
// This is the standalone help portal, so we don't link to the marketing
// site here. The logo lives at /public/logo.svg — replace that file to
// drop in the real .webp / .png and the navbar picks it up automatically.

import { Link } from 'react-router-dom';
import { openSearch } from './SearchModal';

// Local logo path — served from /public, no external CDN dependency.
const LOGO_URL = '/src/images/EduateLogo.svg';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar__inner">
        {/* Clicking the logo goes back to the help center home. */}
        <Link to="/" className="navbar__logo">
          <img src={LOGO_URL} alt="Help Center" />
        </Link>

        <ul className="navbar__menu">
          {/* Search trigger — opens the modal via openSearch().
              Wrapped in an arrow so the click event isn't passed as the
              `prefill` argument. */}
          <li>
            <button
              className="search-trigger"
              aria-label="Search the knowledge base"
              onClick={() => openSearch()}
              type="button"
            >
              🔍 <span className="search-trigger__label">Search</span>
            </button>
          </li>

          <li>
            <Link to="/" className="active">All Guides</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
